import { render, staticRenderFns } from "./PackagePrice.vue?vue&type=template&id=19f12f08&scoped=true"
import script from "./PackagePrice.vue?vue&type=script&lang=js"
export * from "./PackagePrice.vue?vue&type=script&lang=js"
import style0 from "./PackagePrice.vue?vue&type=style&index=0&id=19f12f08&prod&scoped=true&lang=css"
import style1 from "./PackagePrice.vue?vue&type=style&index=1&id=19f12f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f12f08",
  null
  
)

export default component.exports